import Button from '@mui//material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const Loadingalert = () => {
    return (
    <Button loading loadingPosition="end" endIcon={<CircularProgress size={20}/>} variant='contained' size="large" ><span>Loading.....</span></Button>
      );
}
 
export default Loadingalert;